import Immutable from 'immutable'
import * as types from '../constants/SportradarActionTypes'

const initialState = Immutable.Map({
	match: Immutable.Map({
        id: null
    }),
    prematch: Immutable.Map({
        id: null
    }),
    leaguetables: null
})

function receivedMatch(state, data){
	return state.set('match', Immutable.fromJS(data));	
}

function receivedLeaguetables(state, sport, category, tournament, season, leaguetables){
	return state.set('leaguetables', Immutable.fromJS({
        sport: sport,
        tournament: tournament,
        category: category,
        season: season,
        leaguetables: leaguetables
    }));
}

function receivedPrematch(state, id, prematch){
	return state.set('prematch', Immutable.fromJS({
        id: id,
        ...prematch
    }));
}

export default function sportradar (state = initialState, action) {
  switch (action.type) {
  	case types.RECEIVED_MATCH:
  		return receivedMatch(state, action.data);
  	case types.RECEIVED_PREMATCH:
  		return receivedPrematch(state, action.id, action.data);
    case types.RECEIVED_LEAGUETABLES:
        return receivedLeaguetables(state, action.sport, action.category, action.tournament, action.season, action.leaguetables);
    case types.RECEIVED_LIVE:
        return state;
    default:
      return state;
  }
}